import { useConfirm } from 'civic-champs-shared/core/modal/hooks'
import useRemoveVolunteer from './useRemoveVolunteer'
import { useCallback } from 'react'
import { volunteerSummary } from './utils'

const useRemoveVolunteerPromptOld = eagerRemoveMany => {
  const confirm = useConfirm()
  const removeVolunteer = useRemoveVolunteer(eagerRemoveMany)

  return useCallback(
    async volunteers => {
      const { numVolunteers, onlyOneVolunteer, volunteerName } = volunteerSummary(volunteers)
      const text = onlyOneVolunteer
        ? `Are you sure you want to remove ${volunteerName} from volunteers?  His/her activities will no longer appear in reports.`
        : `Are you sure you want to remove ${numVolunteers} volunteers?  Their activities will no longer appear in reports.`
      const confirmed = await confirm(text, {
        title: 'Remove Volunteer',
        confirmText: 'Remove Volunteer',
        rejectText: 'Cancel',
      })

      if (confirmed) {
        await removeVolunteer(volunteers)
      }
    },
    [confirm, removeVolunteer],
  )
}

export default useRemoveVolunteerPromptOld
